import {useMediaQuery} from "./useMediaQuery";

export const useIsMobile = () => {
	const isMobile = useMediaQuery("(max-width: 768px)");
	const isMobileShare = "share" in navigator && isMobile;

	return {isMobileShare, isMobile};
};
